import { takeEvery } from 'redux-saga/effects';
import { ADD_CAROUSEL, addCarouselEffect, REQUEST_NEW_VIDEOS, requestNewVideosEffect } from 'pages/home.page';

export const videoCarouselSaga = function* () {
  yield takeEvery(REQUEST_NEW_VIDEOS, requestNewVideosEffect);
  yield takeEvery(ADD_CAROUSEL, addCarouselEffect);
};
